import { BRAND_P, BRAND_P_BOX, BRAND_WORD, BRAND_WORD_BOX } from '@shkola/design';

/*
 * The logo of Parta on the site (31.10, «PΛRTΛ», `packages/design/src/brand.ts`): the word, and the bold
 * P alone on an ink tile for an icon. One colour: the ink by default, `currentColor` follows the text.
 */

/** The word PΛRTΛ, `height` high. */
export function BrandWord({
  height = 18,
  color = 'currentColor',
  className = '',
}: {
  height?: number;
  color?: string;
  className?: string;
}) {
  return (
    <svg
      viewBox={`0 0 ${BRAND_WORD_BOX.width} ${BRAND_WORD_BOX.height}`}
      height={height}
      width={(height * BRAND_WORD_BOX.width) / BRAND_WORD_BOX.height}
      role="img"
      aria-label="Parta"
      className={`shrink-0 ${className}`}
    >
      <path d={BRAND_WORD} fill={color} fillRule="evenodd" />
    </svg>
  );
}

/** The bold P on a tile of the ink (an icon); `inverse` — the ink P on the paper. */
export function BrandMark({
  size = 32,
  inverse = false,
  className = '',
}: {
  size?: number;
  inverse?: boolean;
  className?: string;
}) {
  const ink = '#241A45';
  const paper = '#F5F3EF';
  const h = BRAND_P_BOX.height;
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      aria-hidden
      focusable="false"
      className={`shrink-0 ${className}`}
    >
      <rect width="64" height="64" rx="16" fill={inverse ? paper : ink} />
      <path
        d={BRAND_P}
        fill={inverse ? ink : paper}
        fillRule="evenodd"
        transform={`translate(${32 - (BRAND_P_BOX.width * 0.34) / 2} ${32 - (h * 0.34) / 2}) scale(0.34)`}
      />
    </svg>
  );
}
